var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_443_16135",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 0H0V30H31V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_443_16135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0H8.5C4.08172 0 0.5 3.58172 0.5 8V22C0.5 26.4183 4.08172 30 8.5 30H22.5C26.9183 30 30.5 26.4183 30.5 22V8C30.5 3.58172 26.9183 0 22.5 0Z",
    fill: "white",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21.433C7 19.4308 8.45485 17.7254 10.432 17.4098L10.6101 17.3814C12.1934 17.1287 13.8066 17.1287 15.3899 17.3814L15.568 17.4098C17.5451 17.7254 19 19.4308 19 21.433C19 22.2984 18.2984 23 17.433 23H8.56697C7.70156 23 7 22.2984 7 21.433Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.5C16.5 12.433 14.933 14 13 14C11.067 14 9.5 12.433 9.5 10.5C9.5 8.567 11.067 7 13 7C14.933 7 16.5 8.567 16.5 10.5Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21.433C7 19.4308 8.45485 17.7254 10.432 17.4098L10.6101 17.3814C12.1934 17.1287 13.8066 17.1287 15.3899 17.3814L15.568 17.4098C17.5451 17.7254 19 19.4308 19 21.433C19 22.2984 18.2984 23 17.433 23H8.56697C7.70156 23 7 22.2984 7 21.433Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.5C16.5 12.433 14.933 14 13 14C11.067 14 9.5 12.433 9.5 10.5C9.5 8.567 11.067 7 13 7C14.933 7 16.5 8.567 16.5 10.5Z",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 14C20.933 14 22.5 12.433 22.5 10.5C22.5 8.567 20.933 7 19 7M21.3899 23H23.433C24.2984 23 25 22.2984 25 21.433C25 19.4308 23.5451 17.7254 21.568 17.4098V17.4098C21.4494 17.3909 21.3293 17.3814 21.2093 17.3814C20.8895 17.3814 20.7902 17.3814 20.2412 17.3814",
    stroke: "white",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0.5H8.5C4.35786 0.5 1 3.85786 1 8V22C1 26.1421 4.35786 29.5 8.5 29.5H22.5C26.6421 29.5 30 26.1421 30 22V8C30 3.85786 26.6421 0.5 22.5 0.5Z",
    stroke: "white",
    strokeOpacity: 0.04
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareer);
export default __webpack_public_path__ + "static/media/career.055829ab0ffd19bf68d386121ab25207.svg";
export { ForwardRef as ReactComponent };